/**
 * @desc 提交审批
 */

import * as defs from '../../baseClass';
import { defHttp } from 'hailuo-http';
export interface Params {}

export function request(
  data: defs.IdRequest,
): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/web/plan/year/submitApproval',
    data,
  });
}

export function mock(data: defs.IdRequest): Promise<defs.StandardReturn<void>> {
  return defHttp.post({
    url: '/mock/web/plan/year/submitApproval',
    data,
  });
}
